import gql from 'graphql-tag';
import React from 'react';
import { View } from 'react-native';
import { useRoute } from '@react-navigation/native';

import { useThemedStyles } from '../../hooks/useThemedStyles';
import PointOfSalePlanogram from './PointOfSalePlanogram';

export const GET_POINT_OF_SALE_PLANOGRAM_MOBILE = gql`
	query($id: String) {
		getMachine(id: $id) {
			id
			assetId
			type
			usesDynamicParlevels
			dynamicParlevelsSettings
			place {
				id
				name
			}
			location {
				id
				name
			}
			planogram {
				id
				planogramItemGroups {
					id
					name
					order
				}
				items {
					id
					created
					selection
					row
					column
					planogramItemGroupId
					enabled
					quantity
					parlevel
					parlevelUnlocked
					capacity
					price
					reportedPrice
					priceBookLocked
					priceBookApplied
					priceBook {
						id
						name
					}
					product {
						id
						name
						imageUrl
						HCGCategory
						HFDCategory
						isFreshFood
						measurementUnit
					}
				}
			}
		}
	}
`;

const PointOfSalePlanogramView = ({
	pointOfSaleId: pointOfSaleIdFromProps,
	pointOfSaleName: pointOfSaleNameFromProps,
}) => {
	const styles = useThemedStyles(createStyles);
	const route = useRoute();
	const pointOfSaleId = pointOfSaleIdFromProps || route.params?.pointOfSaleId || route.params?.machineId;
	const pointOfSaleName = pointOfSaleNameFromProps || route.params?.pointOfSaleName || route.params?.machineName;

	return (
		<View style={styles.container}>
			<PointOfSalePlanogram
				id={pointOfSaleId}
				query={GET_POINT_OF_SALE_PLANOGRAM_MOBILE}
				pointOfSaleName={pointOfSaleName}
			/>
		</View>
	);
};

const createStyles = ({ ui: { colors } }) => ({
	container: {
		backgroundColor: colors.canvas,
		flex: 1,
	},
});

export default PointOfSalePlanogramView;
